var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    tabIndex: 1,
    viewBox: "0 0 36 36",
    className: "svg-with-world",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8765 6.16542C14.9676 7.96992 14.2731 9.87075 13.8022 11.8303C14.9452 12.086 16.1142 12.2377 17.2962 12.2808V6C16.817 6.02752 16.3432 6.08269 15.8765 6.16542Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4909 13.209C21.251 13.4852 19.9852 13.6457 18.7046 13.6888V17.2947H22.9186C22.8819 15.9191 22.7387 14.5529 22.4909 13.209Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1244 6.16538C19.6579 6.08269 19.1841 6.02752 18.7051 6V12.2804C19.8868 12.2378 21.0545 12.0877 22.1984 11.832C21.7274 9.87155 21.0325 7.96908 20.1244 6.16538Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7051 23.7188V29.9992C19.1843 29.9716 19.6583 29.9164 20.125 29.8337C21.0087 28.0807 21.7182 26.185 22.2023 24.168C21.0572 23.9118 19.8882 23.7614 18.7051 23.7188Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.328 18.7051C24.2905 20.1996 24.134 21.6851 23.8604 23.1452C25.261 23.5608 26.6084 24.1233 27.8955 24.8307C29.1454 23.0281 29.873 20.9234 30.0003 18.7051H24.328Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7988 24.168C14.254 26.0645 14.9363 27.9692 15.8761 29.8336C16.3429 29.9164 16.8169 29.9716 17.2961 29.9991V23.7188C16.113 23.7614 14.944 23.9118 13.7988 24.168Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5098 13.209C13.2623 14.5523 13.1186 15.9184 13.082 17.2962H17.296V13.6909C16.0152 13.6475 14.7483 13.485 13.5098 13.209Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10536 11.1699C6.85544 12.9726 6.12785 15.0773 6.00049 17.2957H11.673C11.7108 15.798 11.8684 14.313 12.1428 12.854C10.7441 12.4395 9.39082 11.8761 8.10536 11.1699Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4361 24.5273C11.2633 24.8828 10.1155 25.3511 8.9873 25.9536C10.3521 27.4961 12.09 28.6884 14.0965 29.3752C13.3936 27.8139 12.8377 26.1925 12.4361 24.5273Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9873 10.0469C10.0911 10.6359 11.2471 11.1127 12.439 11.4733C12.8405 9.80997 13.3957 8.18711 14.0984 6.625C12.1778 7.28191 10.4143 8.43428 8.9873 10.0469Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6728 18.7051H6.00049C6.12785 20.9234 6.85539 23.0281 8.10527 24.8307C9.39096 24.1241 10.7382 23.5613 12.1405 23.1452C11.8668 21.6851 11.7103 20.1996 11.6728 18.7051Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9019 6.625C22.604 8.18697 23.159 9.81105 23.5607 11.475C24.7599 11.1119 25.907 10.6384 27.0137 10.0475C25.6453 8.50089 23.9052 7.31017 21.9019 6.625Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5651 24.5273C23.1637 26.1918 22.6079 27.8132 21.9048 29.3752C23.9117 28.6883 25.6495 27.4958 27.014 25.9536C25.9326 25.3762 24.7892 24.8983 23.5651 24.5273Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.082 18.7051C13.1183 20.0802 13.2609 21.447 13.5078 22.7913C14.7485 22.5148 16.0149 22.3541 17.2963 22.311V18.7051H13.082Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.896 11.1699C26.6357 11.8627 25.2898 12.4317 23.8579 12.8563C24.1325 14.3158 24.2904 15.8004 24.3283 17.2956H30.0008C29.8734 15.0772 29.1459 12.9726 27.896 11.1699Z",
    fill: "#777081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7051 18.7051V22.311C19.9865 22.3541 21.2529 22.5148 22.4936 22.7913C22.7405 21.447 22.8831 20.0802 22.9194 18.7051H18.7051Z",
    fill: "#777081"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.00049,
    y: 6,
    width: 27,
    height: 27,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWd);
export default __webpack_public_path__ + "static/media/wd.8d09054a.svg";
export { ForwardRef as ReactComponent };